import React from "react";
import { FloatingLabel, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FieldError } from "react-hook-form";

type SelectProps = {
  label: React.ReactNode;
  options: OptionProps[];
  register: any;
  errorsMessage?: FieldError | undefined;
  tooltipMessage?: string;
  onSelect?: (selectedValue: string | number) => void;
  defaultValue?: string | number;
  value?: string | number;
  helpElement?: React.ReactNode;
};

type OptionProps = {
  value?: string | number;
  label: string;
};

export const FloatSelectComponent = ({
  label,
  options,
  register,
  errorsMessage,
  tooltipMessage = "",
  onSelect,
  defaultValue,
  value,
  helpElement,
}: React.PropsWithChildren<SelectProps>) => {
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    if (onSelect) {
      onSelect(selectedValue);
    }
    if (register && register.onChange) {
      register.onChange(event);
    }
  };
  const selectElement = (
    <Form.Select
      {...register}
      defaultValue={defaultValue}
      value={value}
      isInvalid={!!errorsMessage?.message}
      onChange={handleSelectChange}
    >
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );

  const tooltipId =
    typeof label === "string"
      ? `tooltip-${label.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase()}`
      : "tooltip-select";

  const renderedLabel = helpElement ? (
    <span className="d-inline-flex align-items-center">
      <span>{label}</span>
      {helpElement}
    </span>
  ) : (
    label
  );

  return (
    <FloatingLabel label={renderedLabel}>
      {tooltipMessage ? (
        <OverlayTrigger
          placement="bottom-start"
          overlay={<Tooltip id={tooltipId}>{tooltipMessage}</Tooltip>}
        >
          {selectElement}
        </OverlayTrigger>
      ) : (
        selectElement
      )}
      {errorsMessage?.message?.toString() && (
        <Form.Control.Feedback type="invalid">
          {errorsMessage?.message?.toString()}
        </Form.Control.Feedback>
      )}
    </FloatingLabel>
  );
};

export default FloatSelectComponent;
